import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

/**
 * XML Http Request (XHR) interceptor.
 *
 * This interceptor sets the 'X-Requested-With' header to 'XMLHttpRequest' for each request in the SPA.
 */
@Injectable()
export class XhrInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, nextHandler: HttpHandler) {
    const xhr = request.clone({
      headers: request.headers.set('X-Requested-With', 'XMLHttpRequest')
    });
    return nextHandler.handle(xhr);
  }

}
